import styles from './DataTablePagination.styles.scss';
import { DataTablePaginationComponent, dataTablePaginationTemplate } from './DataTablePagination';
export const chameleonDataTablePagination = DataTablePaginationComponent.compose({
    baseName: 'data-table-pagination',
    template: dataTablePaginationTemplate,
    styles,
});
